export default "__VITE_ASSET__jS2AZAN3__"